import React from 'react';
import DataTable from 'react-data-table-component';
import { Order, Product } from '../../interfaces/user';

interface Props {
  orders: Order[];
  search: string;
  onSearchChange: (val: string) => void;
  onPaymentClick: (paymentId: string | null) => void;
  onItemsClick: (order: Order) => void;
}

const OrderHistory: React.FC<Props> = ({ orders, search, onSearchChange, onPaymentClick, onItemsClick }) => {
  const filteredOrders = orders.filter(order =>
    order.status.toLowerCase().includes(search.toLowerCase()) ||
    order.paymentId?.toLowerCase().includes(search.toLowerCase()) ||
    order.totalAmount.toString().toLowerCase().includes(search.toLowerCase()) ||
    order.createdAt.toString().toLowerCase().includes(search.toLowerCase())
  );

  const orderColumns = [
    {
      name: 'Total Amount',
      selector: (row: Order) => `₹${parseFloat(row.totalAmount).toFixed(2)}`,
      sortable: true,
      right: true,
    },
    {
      name: 'Items Count',
      cell: (row: Order) => (
        <span
          style={{ color: 'blue', cursor: 'pointer', textDecoration: 'underline' }}
          onClick={() => onItemsClick(row)}
        >
          {row.items?.length ?? 0}
        </span>
      ),
      sortable: true,
      right: true,
    },
    {
      name: 'Status',
      selector: (row: Order) => row.status,
      sortable: true,
    },
    {
      name: 'Payment ID',
      cell: (row: Order) => (
        <a
          style={{ color: 'blue', cursor: 'pointer', textDecoration: 'underline' }}
          onClick={(e) => {
            e.stopPropagation();
            onPaymentClick(row.paymentId);
          }}
        >
          {row.paymentId ?? 'N/A'}
        </a>
      ),
      sortable: true,
    },
    {
      name: 'Order Type',
      selector: (row: Order) => row.orderType ?? 'N/A',
      sortable: true,
    },
    {
      name: 'Payment Y/N',
      selector: (row: Order) => row.paymentYN ?? 'N/A',
      sortable: true,
    },
    {
      name: 'Created At',
      selector: (row: Order) => new Date(row.createdAt).toLocaleString(),
      sortable: true,
    },
  ];

  return (
    // <div className="card mb-4">
    //   <div className="card-header bg-primary text-white">
    //     <h3 className="mb-0">Order History</h3>
    //   </div>
      <div className="card-body">
        <DataTable
          columns={orderColumns}
          data={filteredOrders}
          pagination
          subHeader
          paginationPerPage={5}
          subHeaderComponent={
            <input
              type="text"
              placeholder="Search orders..."
              value={search}
              onChange={(e) => onSearchChange(e.target.value)}
              className="form-control"
            />
          }
        />
      </div>
    // </div>
  );
};

export default OrderHistory;
